const enterSnapshots = new Map();

const asTimestamp = (value) =>
  typeof value === "number" && Number.isFinite(value) && value > 0 ? value : 0;

/**
 * First read in a visit wins, so marking lastSeenAt (and remounts) do not
 * hide the "new" chips until the user leaves Insights or reloads.
 */
export const getBrandInsightsLastViewedAtOnEnter = (ownerKey, dbLastSeenAt) => {
  if (!ownerKey) {
    return asTimestamp(dbLastSeenAt);
  }
  if (enterSnapshots.has(ownerKey)) {
    return enterSnapshots.get(ownerKey);
  }
  const previous = asTimestamp(dbLastSeenAt);
  enterSnapshots.set(ownerKey, previous);
  return previous;
};

export const clearBrandInsightsEnterSnapshot = (ownerKey) => {
  enterSnapshots.delete(ownerKey);
};
